<template>
  <div class="cleaning-times">
    <FormHeading
      :ordinal="`${stepNumber}.1`"
      :title="$t('estimate.steps.rate.heading')"
    />
    <div class="cleaning-times__top-row">
      <Input
        name="hourly_rate"
        inputType="number"
        :initialValue="initialValues.hourly_rate"
        :label="getFieldLabel('hourly_rate')"
        :min="1"
        :precision="2"
        @change="$emit('hourlyRateChange', $event)"
      />
      <Input
        name="cleaners_amount"
        inputType="number"
        :initialValue="initialValues.cleaners_amount"
        :label="getFieldLabel('cleaners_amount')"
        :min="1"
        @change="$emit('cleanersAmountChange', $event)"
      />
      <Input
        name="revised_hourly_rate"
        inputType="number"
        :precision="2"
        :initialValue="initialValues.revised_hourly_rate"
        :label="getFieldLabel('revised_hourly_rate')"
      />
    </div>
    <FormHeading
      :ordinal="`${stepNumber}.2`"
      :title="$t('estimate.steps.rate.heading-2')"
      :subtitle="$t('estimate.steps.rate.subheading-2')"
    />
    <div class="cleaning-times__bottom-row">
      <Input
        v-for="multiplier in multipliers"
        inputType="number"
        :initialValue="initialValues.multipliers[multiplier]"
        :key="multiplier"
        :name="`multipliers.${multiplier}`"
        :precision="2"
        :label="getMultiplierFieldLabel(multiplier)"
      />
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import estimateFormMixin from '@/common/mixins/estimate-form';
import FormHeading from '@/components/FormHeading';
import { isShape } from '@/common/prop-validators';
import { Input } from '@/components/common';

const { mapState } = createNamespacedHelpers('estimate');

const multipliers = [
  'one_time',
  'first',
  'weekly',
  'bi_weekly',
  'monthly',
  'spring_deep',
  'move_in_out',
];

export default {
  name: 'CleaningTimesForm',
  components: { Input, FormHeading },
  mixins: [estimateFormMixin],
  data() {
    return { multipliers };
  },
  props: {
    step: {
      type: Object,
      validator: isShape({
        component: Object,
        label: String,
        heading: String,
        id: String,
      }),
    },
    stepNumber: {
      type: Number,
    },
  },
  methods: {
    getFieldLabel(fieldName) {
      return this.$t(`cleaningTimes.fieldLabels.${fieldName}`);
    },
    getMultiplierFieldLabel(multipier) {
      return this.$t(`cleaningTimes.fieldLabels.multipliers.${multipier}`);
    },
  },
  computed: {
    ...mapState({
      initialValues(state) {
        const { data: currentValues } = state.current;
        const { data: defaultValues } = this.settings;
        const hourly_rate = currentValues.hourly_rate || defaultValues.hourly_rate;
        const cleaners_amount = currentValues.cleaners_amount || defaultValues.cleaners_amount;
        const revised_hourly_rate = currentValues.revised_hourly_rate
          || hourly_rate * cleaners_amount;

        return {
          hourly_rate,
          cleaners_amount,
          revised_hourly_rate,
          multipliers: currentValues.multipliers || defaultValues.multipliers,
        };
      },
    }),
  },
};
</script>

<style lang="scss" scoped>
  .cleaning-times {
    @include md-up {
      margin: 0 -100px;
    }

    &__top-row {
      border-bottom: 1px solid $grayLight;
      margin-bottom: 24px;
      padding-bottom: 20px;

      @include md-up {
        display: flex;
        justify-content: space-between;
        margin-bottom: 63px;
        padding-bottom: 40px;

        .ant-form-item {
          flex: 0 0 calc(33% - 14px);
        }
      }
    }

    &__bottom-row {
      @include md-up {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .ant-form-item {
          &:nth-child(-n+3) {
            flex: 0 0 calc(33% - 14px);
          }

          &:nth-child(n+4) {
            flex: 0 0 calc(25% - 18px);
          }
        }
      }
    }
  }
</style>
